import QRCode from "../../../api/qr-code/QRCode";
import {createContext} from "react";

type QRCodeDetailsContextType = {
    /**
     * Selected QR Code
     * @author Kacper Faber
     * @since 0.1.8
     */
    qrCode: QRCode | undefined;

    /**
     * Is actually fetching data from API?
     * @author Kacper Faber
     * @since 0.1.8
     */
    isFetching: boolean;
};

/**
 * Default values.
 * @author Kacper Faber
 * @since 0.1.8
 */
const defaults: QRCodeDetailsContextType = {
    qrCode: undefined,
    isFetching: false,
}

/**
 * Context to store data
 * @author Kacper Faber
 * @since 0.1.8
 */
const ctx = createContext<QRCodeDetailsContextType>(defaults);

export default ctx;